/* eslint-disable */

function check_sites_available() {
  jQuery.ajax({
    type       : "GET",
    data       : { 
      posts: filterIDs,
      dataType   : "jsonp",
      action:'return_sites_available',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        data = JSON.parse(data);
        var sites_available = data[0];
        var cats_available = data[1];

        $('.blog-id').addClass('disabled');

        if( sites_available != null && sites_available.length > 0 ) {

          for(i = 0; i < sites_available.length; i++)  {

            $('[data-filter="' + sites_available[i] + '"]').removeClass('disabled');

          }
        }

        $('.cat-id').addClass('disabled');

        if( cats_available != null && cats_available.length > 0 ) {

          for(i = 0; i < cats_available.length; i++)  {

            $('[data-filter="cat-' + cats_available[i] + '"]').removeClass('disabled');

          }
        }
      }
    },
  });
}

// only check on news page

var sPage = window.location.pathname;

$(document).ready(function() {
  if(sPage == "/news/"){
    check_sites_available();
  }
});

$('.news__filter_toggle').click(function() {
  $('.news__filter').toggleClass('active');
});

// Focus Areas Filtering

$('.cat-id:not("disabled"), .blog-id:not("disabled")').click(function(e) {
  e.preventDefault();
  $(this).toggleClass('active');

  var $dataAttr = $(this).data('filter');

  // CHECK IF IT IS ALREADY THERE
  if($("#results li[data-filter='" + $dataAttr +"']").length > 0) {
    $("#results li[data-filter='" + $dataAttr +"']").remove();
    $("li[data-filter='" + $dataAttr +"']").removeClass('active');
  } else {
    $(this).clone(true).appendTo('#results');
  }

  // filter results

  var $container = $('#replaceNews');
  var $ajaxcontainer = $('.news__ajax');
  var categories = new Array();
  var sites = new Array();
  var catLength = $('#results .cat-id').length;
  var siteLength = $('#results .blog-id').length;

  $container.empty();
  $ajaxcontainer.empty();

  if(catLength > 0) {
    $('#results .cat-id').each( function() {
      catconvert = $(this).data('filter').substring('cat-'.length);
      categories.push(catconvert);
    });
  }

  if(siteLength > 0) {
    $('#results .blog-id').each( function() {
      sites.push($(this).data('filter'))
    });
  }

  pageNumber = 1;

  jQuery.ajax({
    type       : "GET",
    data       : { 
      posts: filterIDs,
      page: pageNumber,
      dataType   : "jsonp",
      action:'more_news_posts',
      categories: categories,
      sites: sites,
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        data = JSON.parse(data);
        var totalPages = data[0];
        var content = data[1];
        var sites_available = data[2];
        var cats_available = data[3];

        $(content).hide().appendTo($container).fadeIn(300);

        $('.blog-id').addClass('disabled');

        if( sites_available != null && sites_available.length > 0 ) {

          for(i = 0; i < sites_available.length; i++)  {

            $('[data-filter="' + sites_available[i] + '"]').removeClass('disabled');

          }
        }

        $('.cat-id').addClass('disabled');

        if( cats_available != null && cats_available.length > 0 ) {

          for(i = 0; i < cats_available.length; i++)  {

            $('[data-filter="cat-' + cats_available[i] + '"]').removeClass('disabled');

          }
        }

        if (pageNumber <= totalPages) {
         $('.moreposts').empty().append('<div>Load more stories</div>');
        }

        if (pageNumber > totalPages) {
         $('.moreposts').empty().append('<div>Sorry, no more stories</div>');
        }
      }
      pageNumber = 2;
    },
  });
});

// Need to know if the results have content or not

$('.news__filter').click(function() {
  var filterItemCount = $('#results > li').length;
  if(filterItemCount > 0) {
    $('.wrapper-3').fadeIn(); // this is the container for the results
  }
  if(filterItemCount == 0) {
    $('.wrapper-3').fadeOut();
  }
});

// AJAX on load

$('.moreposts').click(function() {
  var $container = $('.news__ajax');
  var categories = new Array();
  var sites = new Array();

  var catLength = $('#results .cat-id').length;
  var siteLength = $('#results .cat-id').length;

  if(catLength > 0) {
    $('#results .cat-id').each( function() {
      categories.push($(this).data('filter'))
    });
  }

  if(siteLength > 0) {
    $('#results .blog-id').each( function() {
      sites.push($(this).data('filter'))
    });
  }

  jQuery.ajax({
      type       : "GET",
      data       : { 
        posts: usedIDs,
        page: pageNumber,
        dataType   : "jsonp",
        action:'more_news_posts',
        categories: categories,
        sites: sites, 
        current_site: current_site,
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        pageNumber++;
        if(data.length) {
          data = JSON.parse(data);
          var totalPages = data[0];
          var content = data[1];

          $(content).hide().appendTo($container).fadeIn(300);

          if (pageNumber > totalPages) {
           $('.moreposts').empty().append('<div>Sorry, no more stories</div>');
          }
        }
      },
    });
  });



// WEBPACK FOOTER //
// ./scripts/routes/news.js